export const slugify = (text) => {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')              // Replace spaces with -
        .replace(/(?!-)([^\p{L}]+)/ug, '') // Remove all non-word chars except -
        .replace(/\-\-+/g, '-')            // Replace multiple - with single -
        .replace(/^-+/, '')                // Trim - from start of text
        .replace(/-+$/, '');               // Trim - from end of text
};

export default slugify;
